<template>
    <div id="cooperativeList">
        <div class="con">
        <img class="imgborder" src="../../assets/vehicleData/border.png" alt="">
        <div class="details">
            <div class="close" @click="close">
                <img src="../../assets/vehicleData/close.png" alt="">
            </div>
            <div class="title">
                <img src="../../assets/vehicleData/left.png" alt="">
                <span class="text">合作社</span>
                <img src="../../assets/vehicleData/right.png" alt="">
            </div>
            <div class="line"><img src="../../assets/vehicleData/line.png" alt=""></div>
            <div class="content">
                <div class="content_left">
                    <img class="bg" src="../../assets/vehicleReview/bg.png" alt="">
                    <div class="search">
                        <el-input v-model="cooperative" placeholder="合作社名称" clearable
                        >
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="handleIconClick">

                            </i>
                        </el-input>
                    </div>
                    <div class="tree-container" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="transparent">
                        <el-tree class="tree" ref="tree" :data="treeList" :props="defaultProps" accordion @node-click="nodeclick" node-key="name" :default-expanded-keys="treeExpandData" :default-checked-keys="treeCheckedData" :filter-node-method="filterNode" >
                        </el-tree>
                    </div>
                </div>
                <div class="content_right">
                    <zny-charts :chartData="chartData" :chartType="'line'"/>
<!--                    <div id="cooperativeLine"></div>-->
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
// import {map} from '../../js/map.js';
import {Chart} from '../../js/echarts';
import eventBus from '@/eventBus.js';
import CooperativeService from '../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.CooperativeService.js';
// import {clearMap} from "../../js/clearMap";
export default {
    data(){
        return{
            cooperative:"",
            treeList:[],
            provincialCenterId:"",
            treeExpandData:[],
            treeCheckedData:[],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            regionName:[],
            count:[],
            areaLevelCount:[],
            cityLevelCount:[],
            nationalLevelCount:[],
            provinceLevelCount:[],
            chartData:{
                show:false,
                option:{}
            }
        }
    },
    watch: {
        cooperative(val) {
            this.$refs.tree.filter(val);
        },
    },
    mounted(){
        this.forCooperativeList();
        this.forLineNum();
    },
    methods:{
        //合作社树
        forCooperativeList(){
            var that=this
            that.treeList=[]
            var depList=JSON.parse(JSON.stringify(that.$store.state.departmentList))
            var hezuosheList=JSON.parse(JSON.stringify(that.$store.state.cooperativeList))
            // console.log(depList,hezuosheList)
            var depMap=new Map();
            depList.forEach(item => {
                depMap.set(item.entityId,item)
            })
            for(var a=0;a<hezuosheList.length;a++){
                var parentId=hezuosheList[a].parentId
                while(parentId&&parentId!=undefined){
                    var dep=depMap.get(parentId)
                    if(dep==undefined){
                        break;
                    }
                    var totalNum = dep.totalNum==undefined?0:dep.totalNum;
                    dep.totalNum=totalNum+1
                    parentId=dep.parentId
                }
            }
            var list=[];
            for(var j=0;j<depList.length;j++){
                var children=[];
                var deps=depMap.get(depList[j].entityId)
                depList[j].name=depList[j].name+"("+deps.totalNum+")"
                for(var index=0;index<hezuosheList.length;index++){
                    if(hezuosheList[index].parentId==depList[j].entityId){
                        children.push(hezuosheList[index])
                    }
                }
                depList[j].children=children
                if(deps.totalNum>0){
                    list.push(depList[j])
                }
            }
            var treeData=[]
            if(list.length>1){
                treeData=that.filterArray(list)
            }else{
                treeData=list
            }
            that.treeList=treeData
            // console.log(treeData)
        },
        filterArray(data, parent) {
            let that = this;
            var id;
            if(localStorage.getItem('layer')=='admin'){
                id='0'
            }else if(localStorage.getItem('layer')=='省'){
                id=localStorage.getItem('provinceId')
            }else if(localStorage.getItem('layer')=='市'){
                id=localStorage.getItem('cityId')
            }else if(localStorage.getItem('layer')=='县'){
                id=localStorage.getItem('areaId')
            }
            var par = parent == undefined ? id : parent
            var tree = [];
            var temp;
            for (var i = 0; i < data.length; i++) {
                if (data[i].parentId == par) {
                    var obj = data[i];
                    temp = that.filterArray(data, data[i].entityId);
                    if (temp.length > 0) {
                        obj.children = temp;
                    }
                    tree.push(obj);
                }
            }
            return tree;
        },
        filterNode(value, data) {
            if(data.id){
                if(!this.cooperative){
                    return true;
                }else if(this.cooperative){
                    return data.name.indexOf(this.cooperative) !== -1
                }
            }
        },
        // 获取树形结构默认展开节点
        getRoleTreeRootNode(provincialCenterId) {
            this.treeExpandData.push(provincialCenterId)   
        },
        // 树形控件节点选中事件
        nodeclick(data){
            if(data.id){
                // console.log(data)
                this.$store.state.details='cooperativeDetails'
                this.$store.state.vehicleDataDialog=false
                this.tractorShow=false
                this.harvesterShow=false
                this.selfPropelledShow=false
                this.towerShow=false
                var that=this
                that.$nextTick(function () {
                    setTimeout(function(){
                        eventBus.$emit('checkCooperative',data.id,1)//车辆id,
                    },500)
                })
            }
        },
        // 折现图数据
        forLineNum(){
            CooperativeService.cooperativeLevelCount()
            .then((res)=>{
                // console.log(res)
                var that=this
                for(var i=0;i<res.length;i++){
                    that.regionName.push(res[i].regionName)
                    that.count.push(res[i].cooperativeLevelInfoVo.count)
                    that.areaLevelCount.push(res[i].cooperativeLevelInfoVo.areaLevelCount)
                    that.cityLevelCount.push(res[i].cooperativeLevelInfoVo.cityLevelCount)
                    that.nationalLevelCount.push(res[i].cooperativeLevelInfoVo.nationalLevelCount)
                    that.provinceLevelCount.push(res[i].cooperativeLevelInfoVo.provinceLevelCount)
                }
                Chart.cooperativeLine(that);
            })
        },
        //搜索合作社
        handleIconClick(){
            // console.log('查找合作社')
            // this.$store.state.details='cooperativeDetails'
        },
        // 点击关闭
        close(){
            // this.$store.state.list=''
            this.$store.state.details=''
            this.$store.state.detailList=''
            this.$store.state.list='centerBot'
        },
    },
    beforeDestroy() {
        var that = this
    }
}
</script>
<style lang="less">
    @import '../../viewsStyle/cooperative/cooperativeList.less';
</style>